import styled, { css } from "styled-components";
import { Table } from "antd";

export const EnhancedAntdTable = styled(Table)`
  .ant-table-filter-dropdown-btns {
    display: flex;
    justify-content: space-around;
  }
`;

const VolumeMetricsDefaultRowStyles = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px;
  justify-content: space-evenly;
`;
export const VolumeMetricsCell = styled("div")`
  font-family: "Manrope-Bold";
  font-size: 14px;
  width: 16.67%;
  color: black;
  &:first-child {
    width: 50%;
    color: #434a54;
  }
  > div {
    &:first-child {
      font-size: 18px;
    }
    &:nth-last-child(n+2) {
      background-color: black;
      color: white;
      border-radius: 11px;
      display: inline-block;
      font-size: 11px;
      margin-top: 2px;
      padding: 4px 7px;
    }
  }
`;

export const VolumeMetricsTableHeader = styled("div")`
  ${VolumeMetricsDefaultRowStyles}
  > ${VolumeMetricsCell} {
    padding: 0 15px 20px 0px;
  }
`;

export const VolumeMetricsTableRow = styled("div")`
  ${VolumeMetricsDefaultRowStyles}
  border-bottom: 1px solid #e8e8e8;
  > ${VolumeMetricsCell} {
    font-size: 14px;
  }
`;
